import React from 'react';
import Button from '../../../composants/Button/Button';
import Banner from '../../../composants/Banner/Banner';
import { AnalyseIaStatut } from '../types';

// Bloc de pré-analyse IA des offres : une bannière orange (action/état, sans icône) qui porte
// l'avertissement à gauche (pré-analyse possible, divulgation des données à accepter, relecture
// impérative) et l'action à droite. Sous le bouton : un circular progress pendant l'analyse, puis
// « Pré-analyse IA terminée » une fois finie. La pré-analyse est one-shot : dès qu'elle est en
// cours, terminée (même partielle) ou en erreur, le bouton reste désactivé. Le résultat pré-remplit
// la grille (commentaires + notes) ; en cas d'échec les champs restent vides et l'acheteur saisit à
// la main.
const NOTICE =
  "Il est possible de procéder à une pré-analyse des offres par le biais de l'intelligence artificielle " +
  'intégrée. À cet effet, il est nécessaire d\'accepter la divulgation des données aux entreprises ' +
  "propriétaires du système. L'intelligence artificielle étant susceptible d'erreurs, il est impératif " +
  'de procéder à une relecture et à une correction éventuelle de sa pré-analyse.';

interface OperationAnalyseIaButtonProps {
  etat: AnalyseIaStatut;
  onLancer: () => void;
}

const LABELS: Record<AnalyseIaStatut, string> = {
  none: "Faire pré-analyser par l'IA",
  en_cours: 'Pré-analyse IA en cours…',
  terminee: 'Pré-analyse IA effectuée',
  terminee_partielle: 'Pré-analyse IA effectuée',
  erreur: 'Pré-analyse IA indisponible',
};

const TITLES: Partial<Record<AnalyseIaStatut, string>> = {
  erreur: "La pré-analyse IA n'a pas abouti — complétez les commentaires et notes manuellement.",
  en_cours: 'Pré-analyse en cours — les champs se remplissent automatiquement.',
};

const OperationAnalyseIaButton: React.FC<OperationAnalyseIaButtonProps> = ({ etat, onLancer }) => {
  const termine = etat === 'terminee' || etat === 'terminee_partielle';
  return (
    <Banner
      variant="warning"
      filled
      className="opms__ia-banner"
      message={
        <span className="opms__ia-banner-inner">
          <span className="opms__ia-banner-text">{NOTICE}</span>
          <span className="opms__ia-banner-action">
            <Button
              value={LABELS[etat]}
              variant="primary"
              disabled={etat !== 'none'}
              onClick={() => onLancer()}
              title={TITLES[etat]}
            />
            {etat === 'en_cours' && (
              <span className="opms__ia-status" aria-live="polite">
                <span className="opms__ia-spinner" aria-hidden="true" />
              </span>
            )}
            {termine && (
              <span className="opms__ia-status opms__ia-status--done" aria-live="polite">
                Pré-analyse IA terminée
              </span>
            )}
          </span>
        </span>
      }
    />
  );
};

export default OperationAnalyseIaButton;
